import React from "react";
import ContentA1 from "@components/blocks/ContentA1/ContentA1";
import SuperTeamData from "@components/blocks/ContentA1/data/SuperTeamData";
import FastAndEasyOnlineShopData from "@components/blocks/ContentA1/data/FastAndEasyOnlineShopData";
import YouKnowMoreData from "@components/blocks/ContentA1/data/YouKnowMoreData";
import InfrastructureData from "@components/blocks/ContentA1/data/InfrastructureData";
import SomeThingBiggerData from "@components/blocks/ContentA1/data/SomeThingBiggerData";
import ContentA2 from "@components/blocks/ContentA2/ContentA2";
import SuperSecurityData from "@components/blocks/ContentA2/data/SuperSecurityData";
import ContentD2 from "@components/blocks/ContentD2/ContentD2";
import ShopikoTemplatesData from "@components/blocks/ContentD2/data/ShopikoTemplatesData";
import ContentD1 from "@components/blocks/ContentD1/ContentD1";
import OurClientsVideoData from "@components/blocks/ContentD1/data/OurClientsVideoData";
import ContentB2 from "@components/blocks/ContentB2/ContentB2";
import OurClientsData from "@components/blocks/ContentB2/data/OurClientsData";

const TabAdvantages = () => {

	return (
	  <>
		  <ContentA1 data={FastAndEasyOnlineShopData} color={'color-brand-green-400'}/>
		  <ContentD2 data={ShopikoTemplatesData} color={'color-brand-green-400'}/>
		  <ContentA1 data={SuperTeamData} color={'color-brand-green-400'}/>
		  <ContentA2 data={SuperSecurityData} columns={3} color={'color-brand-green-400'}/>
		  <ContentA1 data={YouKnowMoreData} color={'color-brand-green-400'}/>
		  <ContentD1
			data={OurClientsVideoData}
			color={'color-brand-green-400'}
			blockSize={'800'}
			videoSize={'360'}
		  />
		  <ContentB2 data={OurClientsData} color={'color-brand-green-400'}/>
		  <ContentA1 data={SomeThingBiggerData} color={'color-brand-green-400'}/>
		  <ContentA1 data={InfrastructureData} color={'color-brand-green-400'}/>
	  </>
	)
}

export default TabAdvantages;